import { render, staticRenderFns } from "./barStackedSimple.vue?vue&type=template&id=0095bc4b&"
import script from "./barStackedSimple.vue?vue&type=script&lang=js&"
export * from "./barStackedSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports